var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_c('span', [_vm._v("행운카드 설정")])]), _c('console-body', [_c('v-layout', {
    staticClass: "align-end"
  }, [_c('v-spacer'), _c('span', {
    staticClass: "mx-1"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" 행운카드초기화 ")])], 1), _c('span', {
    staticClass: "mx-1"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.test
    }
  }, [_vm._v(" 행운카드테스트 ")])], 1), _c('span', {
    staticClass: "mx-1"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.stopTest
    }
  }, [_vm._v(" 행운카드중지 ")])], 1)], 1), _c('v-data-table', {
    staticClass: "mt-2 elevation-1",
    attrs: {
      "items": _vm.configs,
      "headers": _vm.configsHeaders,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _vm.$hasScope(['root', 'admin']) ? _c('v-icon', {
          staticClass: "ml-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v("mdi-delete")]) : _vm._e()];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")) + " ")];
      }
    }, {
      key: "item.image",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "src": item.image,
            "max-width": "96",
            "height": "96",
            "contain": ""
          }
        })];
      }
    }, {
      key: "item.percentage",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.percentage) + "% ")];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "my-4",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _vm.$hasScope(['root', 'admin']) ? _c('v-btn', {
    attrs: {
      "color": "accent",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "dark": ""
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }